import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';

import { MediumFacade, MediumGroup, TravelCardType } from '@ridango/components';
import { AllowedCardTypes, AppStartupService, BaseComponent } from '@ridango/core';

import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TravelCardInput } from '../purchase-medium.model';

@Component({
    selector: 'rwidget-travel-card-input',
    templateUrl: './travel-card-input.component.html'
})
export class TravelCardInputComponent extends BaseComponent implements OnInit, OnDestroy {
    mediumGroups$: Observable<MediumGroup[]> = this.mediumFacade.availableMediumGroups$;

    @Input() required = false;
    @Input() reset: Observable<boolean>;
    @Input() disabled: Observable<boolean>;

    cardNumberForm: FormGroup;
    showCardTypeSelect: boolean;
    allowedCardTypes: AllowedCardTypes[] = [];
    selectedCardType: AllowedCardTypes;
    mediumGroups: MediumGroup;

    @Output() onChange = new EventEmitter<TravelCardInput>();

    constructor(
        private appConfig: AppStartupService,
        private translate: TranslateService,
        private mediumFacade: MediumFacade
    ) {
        super();
    }

    ngOnInit() {
        this.reset.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => {
            this.cardNumberForm.controls['card_number'].setValue('');
        });

        this.disabled.pipe(takeUntil(this.componentDestroyed$)).subscribe((isDisabled) => {
            if (isDisabled) {
                this.cardNumberForm.disable();
            } else {
                this.cardNumberForm.enable();
            }
        });

        this.cardNumberForm = new FormGroup({
            card_number: new FormControl('', [Validators.pattern('[0-9]*')])
        });

        this.mediumGroups$.pipe(takeUntil(this.componentDestroyed$)).subscribe((groups) => {
            this.mediumGroups = groups.find(({ type }) => type === 'Travelcard');
        });

        const cardRegionProperty = this.appConfig.getPropertyByCode('WEB_ALLOWED_CARDS');
        if (cardRegionProperty) {
            const regionCardTypes = JSON.parse(cardRegionProperty.value);
            regionCardTypes.forEach((t) => {
                t['name'] = this.translate.instant(t.translationTag);

                if (this.mediumGroups.travelcardTypes.includes(t.type)) {
                    this.allowedCardTypes.push(t);
                }
            });
        }

        if (this.allowedCardTypes.length <= 1) {
            const patternLength = this.allowedCardTypes.map((el) => el.cardNumberLength);

            this.cardNumberForm.controls['card_number'].setValidators([
                Validators.pattern('[0-9]*'),
                Validators.minLength(patternLength[0]),
                Validators.maxLength(patternLength[0])
            ]);
        } else {
            this.showCardTypeSelect = true;
            this.cardNumberForm.controls.card_number.disable();
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    change() {
        let cardType;

        if (this.selectedCardType || this.allowedCardTypes.length) {
            cardType = this.selectedCardType ? this.selectedCardType.type : this.allowedCardTypes[0].type;
        } else {
            cardType = TravelCardType.TravelCardU;
        }

        this.onChange.emit({
            type: cardType,
            value: this.cardNumberForm.controls['card_number'].value,
            isValid: this.cardNumberForm.valid
        });
    }

    cardTypeSelected(event) {
        this.selectedCardType = event;
        this.cardNumberForm.controls.card_number.enable();
        this.cardNumberForm.controls['card_number'].setValue('');
        this.cardNumberForm.controls['card_number'].setValidators([
            Validators.pattern('[0-9]*'),
            Validators.minLength(this.selectedCardType.cardNumberLength),
            Validators.maxLength(this.selectedCardType.cardNumberLength)
        ]);
    }
}
